import { IModalActions, IModalButton } from './interface'

export const createButtons = (props: IModalActions): IModalButton[] => {
  const buttons: IModalButton[] = []
  if (props.cancelButton) {
    buttons.push({
      className: 'cancel',
      disabled: props.cancelButton.disabled ?? false,
      handleClick: props.cancelButton.handleClick,
      text: props.cancelButton.text,
      type: 'button',
      variant: props.cancelButton?.variant || 'secondary'
    })
  }
  buttons.push({
    className: 'confirm',
    disabled: props.confirmButton.disabled,
    handleClick: props.confirmButton.handleClick,
    href: props.confirmButton.href,
    loading: props.confirmButton.loading,
    text: props.confirmButton.text,
    type: props.confirmButton.type,
    variant: props.confirmButton?.variant || 'primary'
  })
  return buttons
}
